import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, gray03, gray04, gray05 } = colors;

export const Container = styled.div`
  width: ${({ fieldWidth }) => `${fieldWidth}%`};
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 16px;
  background-color: transparent;
  font-size: 14px;
  color: ${gray01};
  border: 1px solid ${gray03};
  border-radius: 5px;

  &::placeholder {
    color: ${gray04};
  }

  &:disabled {
    opacity: 0.6;
    color: ${gray01};
    background-color: ${gray05};
  }
`;

export const PercentLabel = styled.label`
  margin: 0;
  position: absolute;
  right: 12px;
  bottom: 8px;
`;
